<template>
    <section class="section-map section-shaped my-0">

        <!-- <div class="container shape-container d-flex justify-content-start">
            <div class="col px-0">

                <div class="card bg-white mb-3" style="width:500px">
                    <div class="card-body" >
                        <p>Book unique hostels.</p>
                        <form>
                            <div class="form-group">
                                <label for="exampleInputEmail1">Location</label>
                                <input type="email" class="form-control" id="exampleInputEmail1" aria-describedby="emailHelp" placeholder="Where">
                                <label for="exampleFormControlSelect1">Number in a Room</label>
                                <select class="form-control" id="exampleFormControlSelect1">
                                    <option>1</option>
                                    <option>2</option>
                                    <option>3</option>
                                    <option>4</option>
                                </select>
                            </div>
                            <button type="submit" class="btn btn-info">Search</button>
                        </form>
                    </div>
                </div>

            </div>
        </div> -->
    </section>
</template>
<script>
    export default {};
</script>
<style>
    .section-map {
        background-image: url(/img/app/cape-coast-map.png);
        background-position: left;
        height: 70vh;
        background-repeat: no-repeat;
        background-size: auto;
    }
</style>
